import type { RouteRecordRaw } from 'vue-router';
import { reversalRoutesDictionary } from './reversal-routes.dictionary.ts';

export const reversalRoutesConfig: RouteRecordRaw = {
  ...reversalRoutesDictionary.reversal.root,
  redirect: { name: reversalRoutesDictionary.reversal.list.name },
  children: [
    {
      ...reversalRoutesDictionary.reversal.list,
      component: () => import('../pages/ReversalList/ReversalListPage.vue'),
    },
    {
      ...reversalRoutesDictionary.reversal.detail,
      component: () =>
        import(
          '../pages/StandardPlanReversalDetail/StandardPlanReversalDetailPage.vue'
        ),
      props: true,
    },
  ],
};
